import { type ActivationStatus } from '../activation/types';
import { genericActionCreator } from './utils';

function createAction<P = void>(
	type: string,
	identifier: 'BASE' | 'SUCCESS' | 'ERROR' | 'PROCESSING',
): [string, (payload: P) => { type: string; payload: P }] {
	const actionType = `ACTIVATE_CONFLUENCE_${type}_${identifier}`;
	const actionCreator = genericActionCreator<typeof actionType, P>(actionType);
	return [actionType, actionCreator];
}

const [PLAN_ACTIVATION, planConfluenceActivation] = createAction('PLAN', 'BASE');
const [START_ACTIVATION, startConfluenceActivation] = createAction('START', 'BASE');

const [CHECK_ACTIVATION_STATUS, checkConfluenceActivationStatus] = createAction(
	'CHECK_STATUS',
	'BASE',
);
const [CHECK_ACTIVATION_STATUS_SUCCESS, checkConfluenceActivationStatusSuccess] = createAction(
	'CHECK_STATUS',
	'SUCCESS',
);
const [CHECK_ACTIVATION_STATUS_ERROR, checkConfluenceActivationStatusFailed] = createAction(
	'CHECK_STATUS',
	'ERROR',
);

const [UPDATE_ACTIVATION_STATUS, updateConfluenceActivationStatus] = createAction<{
	status: ActivationStatus;
}>('UPDATE_STATUS', 'BASE');

const [MARK_ACTIVATION_COMPLETED, markActivationCompleted] = createAction('MARK_COMPLETED', 'BASE');

const [MARK_ACTIVATION_ERROR, markActivationFailed] = createAction('MARK_ERROR', 'BASE');

export {
	PLAN_ACTIVATION,
	planConfluenceActivation,
	START_ACTIVATION,
	startConfluenceActivation,
	CHECK_ACTIVATION_STATUS,
	CHECK_ACTIVATION_STATUS_ERROR,
	CHECK_ACTIVATION_STATUS_SUCCESS,
	checkConfluenceActivationStatus,
	checkConfluenceActivationStatusFailed,
	checkConfluenceActivationStatusSuccess,
	UPDATE_ACTIVATION_STATUS,
	updateConfluenceActivationStatus,
	MARK_ACTIVATION_COMPLETED,
	markActivationCompleted,
	MARK_ACTIVATION_ERROR,
	markActivationFailed,
};
